module.exports = __webpack_public_path__ + "static/img/001.6c190afd.png";